export function getAccountType(account){
	if(!account){
		return 'Account';
	}
	switch (account.account_type_token) {
		case 'student':
			return 'Student Loan';
		case 'savings':
			return 'Emergency Savings Account';
		case '529':
			return 'College savings plan';
		case 'education savings account':
			return 'Tax-advantaged Education Savings Account (ESA)';
		default:
			return 'Account';
	}
}

export function reallocateDeletedAllocation(deletedAllocation, remainingAccounts){
	if(!remainingAccounts || remainingAccounts.length === 0){
		return [];
	}
	const split = Math.round(parseInt(deletedAllocation)/remainingAccounts.length);
	return remainingAccounts.map(account=>{
		account.account_allocation = parseInt(account.account_allocation || 0)+split;
		return account;
	});
}

export function manualOptionCloseAction(selectedAccountType, initSpinwheelDim, setShowManualSavingsPopup, setShowManualOptionPopup, openAddPopup = false){
	setShowManualOptionPopup(false);
	if(openAddPopup){
		switch(selectedAccountType){
			case 'student':
				initSpinwheelDim(true,true);
				break;
			case 'savings':
				setShowManualSavingsPopup(true);
				break;
			default:
				break;
		}
	}else{
		setTimeout(()=>{document.body.style.overflow = 'scroll';},30);
	}
}

export function institutionPopupCloseAction(setShowInstitutionPopup, plaidHandler, setAccountsResponse, setShowNewAccountPopup, restoreScroll, data){
	setShowInstitutionPopup(false);
	if(!data){
		return;
	}
	if(data === 'new'){
		plaidHandler && plaidHandler.open && plaidHandler.open();
		return;
	}
	if(data.accounts){
		setAccountsResponse(data);
		setShowNewAccountPopup(true);
	}
	if(restoreScroll){
		setTimeout(()=>{document.body.style.overflow = 'scroll';},30);
	}
}

export function onExitAction(organizationLike, setShowManualOptionPopup){
	if(organizationLike && organizationLike['organization_allow_manual_savings'] === 'yes'){
		setShowManualOptionPopup(true);
	}
	setTimeout(()=>{document.body.style.overflow = 'scroll';},30);
}
